import classNames from 'classnames';
import React from 'react';
// import { SpriteSvg, SpriteSvgType } from '../../../components/sprite-svg';
import { GameMenuKey } from '../../../model';
import { getPathnameByGameInfo } from '../lib';
import OverviewDefault from '../../../assets/svg/overview-default.svg';
import OverviewActive from '../../../assets/svg/overview-active.svg';
import settingIcon from '../../../assets/svg/setting-icon.svg';
import settingIconHover from '../../../assets/svg/setting-icon-hover.svg';
import getFormatMessage from '../../../locales/get-format-message';

interface IProps {
  readonly selectedMenuID: string;
  readonly onToRouter: (pathname: string) => void;
}

export const MenuHeader = (props: IProps) => {
  const onToRouter = (key: GameMenuKey) => {
    return () => {
      props.onToRouter(getPathnameByGameInfo(key));
    };
  };

  return (
    <div className="sidebar-head">
      <div className="sidebar-masthead">
        <div className="col-content" onClick={onToRouter(GameMenuKey.Overview)}>
          <div
            className={classNames(
              'masthead-title',
              props.selectedMenuID === GameMenuKey.Overview ? 'active' : ''
            )}
          >
            {/* <span className="icon">
              <SpriteSvg type={SpriteSvgType.HomeCircle} />
            </span> */}
            <span className="icon">
              {props.selectedMenuID === GameMenuKey.Overview ? (
                <img src={OverviewActive} className="icon-img" />
              ) : (
                <img src={OverviewDefault} className="icon-img" />
              )}
            </span>
            <span className="text">{getFormatMessage('title_overview')}</span>
          </div>
        </div>
        <div className="col-action" onClick={onToRouter(GameMenuKey.GameInfo)}>
          {props.selectedMenuID === GameMenuKey.GameInfo ? (
            <img src={settingIconHover} className="action-btn" />
          ) : (
            <img src={settingIcon} className="action-btn" />
          )}
        </div>
      </div>
    </div>
  );
};
